// src/components/SharedComponents/Styles/RemovableModalImage.Style.js
// @flow

const removableModalImageStyles = {
  container: (theme) => ({
    display: 'inline-block',
  }),
  image: (theme) => ({
    maxHeight: 150,
    width: 'auto',
    height: 'auto',
    borderRadius: 24,
    cursor: 'pointer'
  }),
  largeImage: (theme) => ({
    maxWidth: '100%',
    height: 'auto',
    borderRadius: theme.shape.borderRadius
  }),
  removeButton: (theme) => ({
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: '#333',
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  })
};

export default removableModalImageStyles;